import { graphql, useStaticQuery } from 'gatsby';

const useCartNotes = () => {
  const data = useStaticQuery<Queries.CartNotesQuery>(graphql`
    query CartNotes {
      contentfulNotification(name: { eq: "Cart Notes" }) {
        description {
          childMarkdownRemark {
            html
          }
        }
      }
    }
  `);

  return data?.contentfulNotification;
};

export default useCartNotes;
